import React, { useState, useEffect } from 'react'

const API = '/cms/api/ai-market-customers'
const ADMIN_KEY = 'aim-admin-84deadf05b47284331cbf654'
const authHeaders = () => ({ 'X-Admin-Key': ADMIN_KEY })

export default function AIMarketCustomersPage() {
  const [customers, setCustomers] = useState([])
  const [loading, setLoading] = useState(true)
  const [total, setTotal] = useState(0)
  const [page, setPage] = useState(1)
  const [search, setSearch] = useState('')
  const [detail, setDetail] = useState(null)
  const [detailLoading, setDetailLoading] = useState(false)

  useEffect(() => { loadCustomers() }, [page])

  async function loadCustomers() {
    setLoading(true)
    try {
      const params = new URLSearchParams({ page, limit: 20 })
      if (search) params.set('keyword', search)
      const res = await fetch(`${API}?${params}`, { headers: authHeaders() })
      if (res.ok) {
        const data = await res.json()
        setCustomers(data.data || [])
        setTotal(data.pagination ? data.pagination.total : 0)
      }
    } catch (e) { console.error(e) }
    setLoading(false)
  }

  async function loadDetail(id) {
    setDetailLoading(true)
    try {
      const res = await fetch(`${API}/${id}`, { headers: authHeaders() })
      if (res.ok) {
        const raw = await res.json()
        const d = raw.data || raw
        setDetail({
          user: d.user || d,
          balance: d.user ? d.user.balance : (d.balance || 0),
          locked_balance: d.user ? d.user.locked_balance : (d.locked_balance || 0),
          totalRecharge: d.totalRecharge || 0,
          videoCount: (d.videos && d.videos.length) || 0,
          rechargeOrders: d.recharges || [],
          usageLogs: d.usages || [],
          contacts: d.contacts || []
        })
      }
    } catch (e) { console.error(e) }
    setDetailLoading(false)
  }

  function handleSearch() { setPage(1); loadCustomers() }

  const totalPages = Math.ceil(total / 20)
  const fenToYuan = (f) => '￥' + ((f || 0) / 100).toFixed(2)

  const statusColor = (s) => s === 'active' ? '#4CAF50' : s === 'banned' ? '#f44336' : '#999'
  const statusText = (s) => s === 'active' ? '正常' : s === 'banned' ? '禁用' : s || '未知'

  if (detail) {
    return (
      <div style={{ padding: 24 }}>
        <button onClick={() => setDetail(null)} style={{
          background: 'none', border: 'none', color: '#e94560', cursor: 'pointer',
          fontSize: 14, marginBottom: 16
        }}>← 返回客户列表</button>
        <h2 style={{ marginBottom: 20 }}>👤 客户详情 - {detail.user.company_name || detail.user.email || '未知'}</h2>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 24 }}>
          <div style={cardStyle}><strong>邮箱</strong><br/>{detail.user.email || '—'}</div>
          <div style={cardStyle}><strong>手机</strong><br/>{detail.user.phone || '—'}</div>
          <div style={cardStyle}><strong>公司</strong><br/>{detail.user.company_name || '—'}</div>
          <div style={cardStyle}><strong>联系人</strong><br/>{detail.user.contact_name || '—'}</div>
          <div style={cardStyle}><strong>可用余额</strong><br/>{fenToYuan(detail.balance)}</div>
          <div style={cardStyle}><strong>冻结金额</strong><br/>{fenToYuan(detail.locked_balance)}</div>
          <div style={cardStyle}><strong>累计充值</strong><br/>{fenToYuan(detail.totalRecharge)}</div>
          <div style={cardStyle}><strong>视频产量</strong><br/>{detail.videoCount} 个</div>
        </div>

        <h3 style={{ marginBottom: 12 }}>💳 充值记录</h3>
        {detail.rechargeOrders && detail.rechargeOrders.length > 0 ? (
          <table style={tableStyle}>
            <thead><tr><th>订单号</th><th>金额</th><th>状态</th><th>时间</th></tr></thead>
            <tbody>
              {detail.rechargeOrders.map(o => (
                <tr key={o.id}>
                  <td style={{ fontSize: 12 }}>{o.order_no}</td>
                  <td>{fenToYuan(o.amount)}</td>
                  <td>{o.status}</td>
                  <td style={{ fontSize: 12 }}>{o.created_at}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : <p style={{ color: '#999' }}>暂无充值记录</p>}

        <h3 style={{ margin: '20px 0 12px' }}>📊 消费记录</h3>
        {detail.usageLogs && detail.usageLogs.length > 0 ? (
          <table style={tableStyle}>
            <thead><tr><th>产品</th><th>动作</th><th>时间</th></tr></thead>
            <tbody>
              {detail.usageLogs.map(u => (
                <tr key={u.id}>
                  <td>{u.product_key}</td>
                  <td>{u.action}</td>
                  <td style={{ fontSize: 12 }}>{u.created_at}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : <p style={{ color: '#999' }}>暂无消费记录</p>}

        <h3 style={{ margin: '20px 0 12px' }}>📮 客服留言</h3>
        {detail.contacts && detail.contacts.length > 0 ? (
          detail.contacts.map(c => (
            <div key={c.id} style={{ background: '#fff', borderRadius: 8, padding: 12, marginBottom: 8, border: '1px solid #eee' }}>
              <div style={{ fontSize: 12, color: '#999', marginBottom: 4 }}>{c.created_at} · {c.status || 'pending'}</div>
              <div style={{ fontSize: 13, whiteSpace: 'pre-wrap' }}>{c.content}</div>
            </div>
          ))
        ) : <p style={{ color: '#999' }}>暂无留言</p>}
      </div>
    )
  }

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ marginBottom: 16 }}>👥 客户列表</h2>

      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <input
          placeholder="搜索邮箱/手机/公司..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleSearch()}
          style={{ flex: 1, padding: '8px 12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 13 }}
        />
        <button onClick={handleSearch} style={{
          padding: '8px 16px', background: '#e94560', color: '#fff', border: 'none',
          borderRadius: 8, cursor: 'pointer'
        }}>搜索</button>
      </div>

      {loading ? <p style={{ color: '#999' }}>加载中...</p> : (
        <>
          <table style={tableStyle}>
            <thead>
              <tr>
                <th>ID</th><th>邮箱</th><th>手机</th><th>公司</th>
                <th>余额</th><th>充值</th><th>用量</th><th>状态</th><th>注册时间</th><th>操作</th>
              </tr>
            </thead>
            <tbody>
              {customers.map(c => (
                <tr key={c.id}>
                  <td>{c.id}</td>
                  <td style={{ maxWidth: 140, overflow: 'hidden', textOverflow: 'ellipsis' }}>{c.email || '—'}</td>
                  <td>{c.phone || '—'}</td>
                  <td style={{ maxWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis' }}>{c.company_name || '—'}</td>
                  <td style={{ fontWeight: 600 }}>{fenToYuan(c.balance)}</td>
                  <td>{fenToYuan(c.recharge_count * 100)}</td>
                  <td>{c.writing_count + c.video_count}</td>
                  <td><span style={{ color: statusColor(c.status), fontWeight: 600, fontSize: 12 }}>
                    {statusText(c.status)}
                  </span></td>
                  <td style={{ fontSize: 11 }}>{c.created_at?.substring(0, 16)}</td>
                  <td>
                    <button onClick={() => loadDetail(c.id)} style={{
                      background: 'none', border: '1px solid #e94560', color: '#e94560',
                      borderRadius: 4, cursor: 'pointer', padding: '2px 8px', fontSize: 12
                    }}>详情</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{ marginTop: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ color: '#999', fontSize: 13 }}>共 {total} 条</span>
            <div style={{ display: 'flex', gap: 4 }}>
              {Array.from({ length: totalPages }, (_, i) => (
                <button key={i} onClick={() => setPage(i + 1)}
                  style={{
                    padding: '4px 12px', border: '1px solid ' + (page === i+1 ? '#e94560' : '#ddd'),
                    borderRadius: 4, background: page === i+1 ? '#e94560' : '#fff',
                    color: page === i+1 ? '#fff' : '#333', cursor: 'pointer', fontSize: 12
                  }}>
                  {i + 1}
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  )
}

const cardStyle = {
  background: '#fff', borderRadius: 10, padding: 14, border: '1px solid #eee', fontSize: 13
}

const tableStyle = {
  width: '100%', borderCollapse: 'collapse', fontSize: 13,
  background: '#fff', borderRadius: 8, overflow: 'hidden'
}
